import DetailContext from '@shared/components/utils/context/detailContext';
import DetailItem from '@components/elements/detail/detailItem';
import DetailRightContainer from '@components/atoms/container/detailRightContainer';
import { useContext } from 'react';

export default function DetailRight() {
  const { assetInfo } = useContext(DetailContext);

  if (assetInfo) {
    const { originalTitle, directors, actors, writers } = assetInfo;
    const data = { originalTitle, directors, actors, writers };
    return (
      <DetailRightContainer id={'detailRight'}>
        {Object.values(data).map((item, key) => {
          return <DetailItem key={key} title={item.title} value={item.value} />;
        })}
      </DetailRightContainer>
    );
  }
}
